import { render } from "./KryptonLayer.vue?vue&type=template&id=41e7f1e8&lang=pug"
import script from "./KryptonLayer.vue?vue&type=script&lang=js"
export * from "./KryptonLayer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__